import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { FileText, Mic, Users, TrendingUp } from 'lucide-react';
const topics = [{
  title: 'Enterprise Logistics Modernization',
  type: 'Strategic Focus',
  icon: TrendingUp
}, {
  title: 'Contested Logistics Strategy',
  type: 'White Paper',
  icon: FileText
}, {
  title: 'Defense Sustainment Innovation',
  type: 'Industry Forum',
  icon: Users
}, {
  title: 'Future of Supply Chain Resilience',
  type: 'Conference Speaking',
  icon: Mic
}];
export function MediaSection() {
  return <Section id="media" variant="charcoal" data-id="element-243">
      <SectionHeader title="Thought Leadership" subtitle="Strategic Insights" data-id="element-244" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-245">
        {topics.map((item, index) => <Reveal key={index} delay={index * 100} data-id="element-246">
            <Card className="group cursor-pointer h-full hover:bg-navy-900 transition-colors" data-id="element-247">
              <div className="flex justify-between items-start mb-4" data-id="element-248">
                <div className="bg-navy-800 p-2 rounded-sm border border-white/10 group-hover:border-gold-500/50 transition-colors" data-id="element-249">
                  <item.icon className="text-gold-500 w-5 h-5" data-id="element-250" />
                </div>
              </div>
              <h4 className="text-lg font-bold text-white mb-2 group-hover:text-gold-500 transition-colors" data-id="element-251">
                {item.title}
              </h4>
              <p className="text-sm text-slate-400 uppercase tracking-wider" data-id="element-252">
                {item.type}
              </p>
            </Card>
          </Reveal>)}
      </div>
    </Section>;
}